import { render, staticRenderFns } from "./beautyContest.vue?vue&type=template&id=747cc813&scoped=true&"
import script from "./beautyContest.vue?vue&type=script&lang=ts&"
export * from "./beautyContest.vue?vue&type=script&lang=ts&"
import style0 from "./beautyContest.scss?vue&type=style&index=0&id=747cc813&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "747cc813",
  null
  
)

export default component.exports